module.exports = __webpack_public_path__ + "static/media/warning.31c5038c.svg";